import { createSelector } from '@ngrx/store';

import { HomePolicy } from '@models/swagger';
import { State } from './reducer';
import { selectGetPolicyState } from '../selectors';

export const getData = createSelector(selectGetPolicyState, (state: State) => state.data);

export const getError = createSelector(selectGetPolicyState, (state: State) => state.error);

export const getLoading = createSelector(selectGetPolicyState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: HomePolicy) => T) =>
  createSelector(selectGetPolicyState, (state: State) => fn(state.data));
